import { Grid } from "@mui/material";
import { tz } from "moment-timezone";
import React from "react";
import { t } from "ttag";
import { countryOptions, countryWithStates, stateOptions, timezoneOptions } from "./siteSetupForm";
import useSiteSetupInputs, { SectionTitle } from "./useSiteSetupInputs";

// Setup form, left column: what and where the site is
const DetailsSection = () => {
  const { formik, row, half, renderText, renderSearchSelect } = useSiteSetupInputs();
  const { values, setFieldValue } = formik;
  const isUS = values.country === countryWithStates;

  const handleCountrySelect = (country: any) => {
    if (country !== countryWithStates) {
      setFieldValue("state", "");
    }
    // Fill the timezone when the country has only one
    const zones = country ? tz.zonesForCountry(country) || [] : [];
    if (zones.length === 1) {
      setFieldValue("timezone", zones[0]);
    }
  };

  return (
    <Grid container columnSpacing={2}>
      <SectionTitle>{t`Details`}</SectionTitle>
      {row(renderText("name", t`Site name`), "name")}
      {row(renderText("description", t`Description`, { multiline: true, rows: 2 }), "description")}
      {row(renderText("address", t`Address`), "address")}
      {row(renderText("city", t`City`), "city")}
      {row(renderText("postalCode", t`Zip`), "postalCode")}
      {half(renderSearchSelect("country", t`Country`, countryOptions, handleCountrySelect), "country")}
      {half(
        renderSearchSelect("state", isUS ? t`State` : t`State (US only)`, stateOptions, undefined, !isUS),
        "state"
      )}
      {row(renderSearchSelect("timezone", t`Time zone`, timezoneOptions), "timezone")}
    </Grid>
  );
};

export default DetailsSection;
